import * as Yup from 'yup';

 const rewardSchema = Yup.object().shape({
    rewards: Yup.string()
    .min(2, 'Too Short!')
    .max(100, 'Too Long!')
    .required('Required'),
    type: Yup.string().required('Required'),
    description: Yup.string().required('Required'),  
    point: Yup.number().required('Required'),
   
 });

export default rewardSchema

